/*
 * @Author: Tahiti
 * @Date: 2025-10-24 10:50:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-10-24 10:50:00
 * @Description: AI Image Page 多语言配置
 * @FilePath: /weryai-web/locales/modules/aiImage.ts
 */
export default {
    zh: {
        // 页面标题
        pageTitle: 'AI 图片生成',
        pageSubtitle: '使用最先进的 AI 模型，将您的创意转化为精美图片',

        // 横幅标题
        text_to_image_banner: '文生图',
        image_to_image_banner: '图生图',

        // 轮播图描述
        carousel_desc_1: '完美一致的角色',
        carousel_desc_2: '超越想象的逼真',
        carousel_desc_3: '你的构想，被完美理解',

        // 工具区域
        tools_title: '图像工具',
        picture_of_life: '生活图片',
        picture_of_life_desc: '为图片的背景配衣服',
        image_elements_editing: '图像元素编辑',
        image_elements_editing_desc: '手动调整复制字体或上传元数据编辑图片',
        image_cropping: '图像裁剪',
        image_cropping_desc: '裁剪图像比例',
        image_quality_upgrade: '图像质量升级',
        image_quality_upgrade_desc: '升级图像质量并提高清晰度',
        figure_video: '人物视频',
        figure_video_desc: '静态图片一键生成视频',
        video_style: '视频风格',
        video_style_desc: '改变当前视频风格',

        // 模型区域
        models_title: '图像模型',
        model_sora2_desc: '逼真的世界和音频模拟',
        try: '体验',
    },
    en: {
        // Page title
        pageTitle: 'AI Image Generation',
        pageSubtitle: 'Transform your creativity into stunning images with the most advanced AI models',

        // Banner titles
        text_to_image_banner: 'Text to Image',
        image_to_image_banner: 'Image to Image',

        // Carousel descriptions
        carousel_desc_1: 'Flawless characters, finally',
        carousel_desc_2: 'Photorealism beyond imagination',
        carousel_desc_3: 'Your vision, perfectly understood',

        // Tools section
        tools_title: 'Image Tools',
        picture_of_life: 'Picture of Life',
        picture_of_life_desc: 'Clothing for the background of the picture',
        image_elements_editing: 'Image Elements Editing',
        image_elements_editing_desc: 'Manually adjust copy font or upload metadata edit pictures',
        image_cropping: 'Image Cropping',
        image_cropping_desc: 'Crop the image proportions',
        image_quality_upgrade: 'Image Quality Upgrade',
        image_quality_upgrade_desc: 'Upgrade the image quality and improve clarity',
        figure_video: 'Figure Video',
        figure_video_desc: 'Static pictures change video with one click',
        video_style: 'Video Style',
        video_style_desc: 'Change the current video style',

        // Models section
        models_title: 'Image Models',
        model_sora2_desc: 'Realistic world & audio simulation',
        try: 'Try',
    },
    ja: {
        // ページタイトル
        pageTitle: 'AI 画像生成',
        pageSubtitle: '最先端のAIモデルで、創造性を素晴らしい画像に変換',

        // バナータイトル
        text_to_image_banner: 'テキストから画像',
        image_to_image_banner: '画像から画像',

        // カルーセル説明
        carousel_desc_1: '完璧に一致したキャラクター',
        carousel_desc_2: '想像を超えるリアリズム',
        carousel_desc_3: 'あなたのビジョン、完璧に理解',

        // ツールセクション
        tools_title: '画像ツール',
        picture_of_life: '生活写真',
        picture_of_life_desc: '画像の背景に服を配置',
        image_elements_editing: '画像要素編集',
        image_elements_editing_desc: 'コピーフォントを手動調整またはメタデータをアップロードして画像を編集',
        image_cropping: '画像トリミング',
        image_cropping_desc: '画像の比率をトリミング',
        image_quality_upgrade: '画像品質アップグレード',
        image_quality_upgrade_desc: '画像品質をアップグレードし、鮮明度を向上',
        figure_video: '人物動画',
        figure_video_desc: '静止画をワンクリックで動画に',
        video_style: '動画スタイル',
        video_style_desc: '現在の動画スタイルを変更',

        // モデルセクション
        models_title: '画像モデル',
        model_sora2_desc: 'リアルな世界とオーディオシミュレーション',
        try: '体験',
    },
    ko: {
        // 페이지 제목
        pageTitle: 'AI 이미지 생성',
        pageSubtitle: '가장 진보된 AI 모델로 창의성을 멋진 이미지로 변환',

        // 배너 제목
        text_to_image_banner: '텍스트에서 이미지',
        image_to_image_banner: '이미지에서 이미지',

        // 캐러셀 설명
        carousel_desc_1: '완벽하게 일치하는 캐릭터',
        carousel_desc_2: '상상을 초월하는 사실성',
        carousel_desc_3: '당신의 비전, 완벽하게 이해',

        // 도구 섹션
        tools_title: '이미지 도구',
        picture_of_life: '생활 사진',
        picture_of_life_desc: '사진 배경에 옷 배치',
        image_elements_editing: '이미지 요소 편집',
        image_elements_editing_desc: '복사 글꼴을 수동으로 조정하거나 메타데이터를 업로드하여 이미지 편집',
        image_cropping: '이미지 자르기',
        image_cropping_desc: '이미지 비율 자르기',
        image_quality_upgrade: '이미지 품질 업그레이드',
        image_quality_upgrade_desc: '이미지 품질을 업그레이드하고 선명도 향상',
        figure_video: '인물 비디오',
        figure_video_desc: '정적 사진을 원클릭으로 비디오로',
        video_style: '비디오 스타일',
        video_style_desc: '현재 비디오 스타일 변경',

        // 모델 섹션
        models_title: '이미지 모델',
        model_sora2_desc: '사실적인 세계 및 오디오 시뮬레이션',
        try: '체험',
    },
    tw: {
        // 頁面標題
        pageTitle: 'AI 圖片生成',
        pageSubtitle: '使用最先進的 AI 模型，將您的創意轉化為精美圖片',

        // 橫幅標題
        text_to_image_banner: '文生圖',
        image_to_image_banner: '圖生圖',

        // 輪播圖描述
        carousel_desc_1: '角色一致性更完美',
        carousel_desc_2: '超越想像的逼真',
        carousel_desc_3: '你的構想，被完美理解',

        // 工具區域
        tools_title: '圖像工具',
        picture_of_life: '生活照片',
        picture_of_life_desc: '為圖片背景搭配風格',
        image_elements_editing: '圖像元素編輯',
        image_elements_editing_desc: '手動調整文字或上傳中繼資料編輯圖片',
        image_cropping: '圖像裁剪',
        image_cropping_desc: '裁剪圖像比例',
        image_quality_upgrade: '圖像品質升級',
        image_quality_upgrade_desc: '升級圖像品質並提高清晰度',
        figure_video: '人物影片',
        figure_video_desc: '靜態圖片一鍵生成影片',
        video_style: '影片風格',
        video_style_desc: '改變目前影片風格',

        // 模型區域
        models_title: '圖像模型',
        model_sora2_desc: '真實世界與音訊模擬',
        try: '體驗',
    },
    pl: {
        // Page title
        pageTitle: 'Generowanie obrazów AI',
        pageSubtitle:
            'Zamień swoją kreatywność w zachwycające obrazy dzięki najnowocześniejszym modelom AI',

        // Banner titles
        text_to_image_banner: 'Tekst→Obraz',
        image_to_image_banner: 'Obraz→Obraz',

        // Carousel descriptions
        carousel_desc_1: 'Spójne postacie bez kompromisów',
        carousel_desc_2: 'Fotorealizm ponad wyobraźnię',
        carousel_desc_3: 'Twoja wizja, perfekcyjnie zrozumiana',

        // Tools section
        tools_title: 'Narzędzia obrazów',
        picture_of_life: 'Zdjęcia z życia',
        picture_of_life_desc: 'Dopasuj styl tła do zdjęcia',
        image_elements_editing: 'Edycja elementów obrazu',
        image_elements_editing_desc:
            'Ręcznie edytuj tekst lub użyj metadanych, aby zmieniać obrazy',
        image_cropping: 'Kadrowanie obrazu',
        image_cropping_desc: 'Przytnij proporcje obrazu',
        image_quality_upgrade: 'Poprawa jakości obrazu',
        image_quality_upgrade_desc: 'Zwiększ jakość i ostrość obrazu',
        figure_video: 'Wideo postaci',
        figure_video_desc:
            'Jednym kliknięciem zamień statyczne zdjęcie w wideo',
        video_style: 'Styl wideo',
        video_style_desc: 'Zmień aktualny styl wideo',

        // Models section
        models_title: 'Modele obrazów',
        model_sora2_desc: 'Realistyczny świat i symulacja dźwięku',
        try: 'Wypróbuj',
    },
    es: {
        // Título de la página
        pageTitle: 'Generación de Imágenes con IA',
        pageSubtitle: 'Transforma tu creatividad en imágenes impresionantes con los modelos de IA más avanzados',

        // Títulos del banner
        text_to_image_banner: 'Texto a Imagen',
        image_to_image_banner: 'Imagen a Imagen',

        // Descripciones del carrusel
        carousel_desc_1: 'Personajes perfectos, finalmente',
        carousel_desc_2: 'Fotorrealismo más allá de la imaginación',
        carousel_desc_3: 'Tu visión, perfectamente comprendida',

        // Sección de herramientas
        tools_title: 'Herramientas de Imagen',
        picture_of_life: 'Foto de Vida',
        picture_of_life_desc: 'Ropa para el fondo de la imagen',
        image_elements_editing: 'Edición de Elementos de Imagen',
        image_elements_editing_desc: 'Ajustar manualmente fuente de copia o cargar metadatos para editar imágenes',
        image_cropping: 'Recorte de Imagen',
        image_cropping_desc: 'Recortar proporciones de imagen',
        image_quality_upgrade: 'Mejora de Calidad de Imagen',
        image_quality_upgrade_desc: 'Mejorar la calidad de imagen y aumentar claridad',
        figure_video: 'Video de Figura',
        figure_video_desc: 'Convertir fotos estáticas en video con un clic',
        video_style: 'Estilo de Video',
        video_style_desc: 'Cambiar el estilo de video actual',

        // Sección de modelos
        models_title: 'Modelos de Imagen',
        model_sora2_desc: 'Simulación de mundo y audio realista',
        try: 'Probar',
    },
    fr: {
        // Titre de la page
        pageTitle: "Génération d'Images IA",
        pageSubtitle: 'Transformez votre créativité en images époustouflantes avec les modèles IA les plus avancés',

        // Titres de la bannière
        text_to_image_banner: 'Texte vers Image',
        image_to_image_banner: 'Image vers Image',

        // Descriptions du carrousel
        carousel_desc_1: 'Personnages parfaits, enfin',
        carousel_desc_2: 'Photoréalisme au-delà de l\'imagination',
        carousel_desc_3: 'Votre vision, parfaitement comprise',

        // Section des outils
        tools_title: "Outils d'Image",
        picture_of_life: 'Photo de Vie',
        picture_of_life_desc: "Vêtements pour l'arrière-plan de l'image",
        image_elements_editing: "Édition d'Éléments d'Image",
        image_elements_editing_desc: 'Ajuster manuellement la police de copie ou télécharger des métadonnées pour éditer des images',
        image_cropping: "Recadrage d'Image",
        image_cropping_desc: "Recadrer les proportions de l'image",
        image_quality_upgrade: "Amélioration de Qualité d'Image",
        image_quality_upgrade_desc: "Améliorer la qualité d'image et augmenter la clarté",
        figure_video: 'Vidéo de Figure',
        figure_video_desc: 'Convertir des photos statiques en vidéo en un clic',
        video_style: 'Style de Vidéo',
        video_style_desc: 'Changer le style de vidéo actuel',

        // Section des modèles
        models_title: "Modèles d'Image",
        model_sora2_desc: 'Simulation de monde et audio réaliste',
        try: 'Essayer',
    },
    de: {
        // Seitentitel
        pageTitle: 'KI-Bilderzeugung',
        pageSubtitle: 'Verwandeln Sie Ihre Kreativität in beeindruckende Bilder mit den fortschrittlichsten KI-Modellen',

        // Banner-Titel
        text_to_image_banner: 'Text zu Bild',
        image_to_image_banner: 'Bild zu Bild',

        // Karussell-Beschreibungen
        carousel_desc_1: 'Perfekte Charaktere, endlich',
        carousel_desc_2: 'Fotorealismus jenseits der Vorstellungskraft',
        carousel_desc_3: 'Ihre Vision, perfekt verstanden',

        // Werkzeugbereich
        tools_title: 'Bildwerkzeuge',
        picture_of_life: 'Lebensbild',
        picture_of_life_desc: 'Kleidung für den Bildhintergrund',
        image_elements_editing: 'Bildelemente Bearbeitung',
        image_elements_editing_desc: 'Schriftart manuell anpassen oder Metadaten hochladen, um Bilder zu bearbeiten',
        image_cropping: 'Bildzuschnitt',
        image_cropping_desc: 'Bildproportionen zuschneiden',
        image_quality_upgrade: 'Bildqualität Upgrade',
        image_quality_upgrade_desc: 'Bildqualität verbessern und Klarheit erhöhen',
        figure_video: 'Figurvideo',
        figure_video_desc: 'Statische Fotos mit einem Klick in Video umwandeln',
        video_style: 'Videostil',
        video_style_desc: 'Aktuellen Videostil ändern',

        // Modellbereich
        models_title: 'Bildmodelle',
        model_sora2_desc: 'Realistische Welt- und Audiosimulation',
        try: 'Probieren',
    },
    ru: {
        // Заголовок страницы
        pageTitle: 'Генерация Изображений ИИ',
        pageSubtitle: 'Преобразуйте свои идеи в потрясающие изображения с помощью самых передовых моделей ИИ',

        // Заголовки баннера
        text_to_image_banner: 'Текст в Изображение',
        image_to_image_banner: 'Изображение в Изображение',

        // Описания карусели
        carousel_desc_1: 'Безупречные персонажи, наконец-то',
        carousel_desc_2: 'Фотореализм за гранью воображения',
        carousel_desc_3: 'Ваше видение, идеально понято',

        // Раздел инструментов
        tools_title: 'Инструменты Изображения',
        picture_of_life: 'Фото Жизни',
        picture_of_life_desc: 'Одежда для фона изображения',
        image_elements_editing: 'Редактирование Элементов Изображения',
        image_elements_editing_desc: 'Вручную настроить шрифт копирования или загрузить метаданные для редактирования изображений',
        image_cropping: 'Обрезка Изображения',
        image_cropping_desc: 'Обрезать пропорции изображения',
        image_quality_upgrade: 'Улучшение Качества Изображения',
        image_quality_upgrade_desc: 'Улучшить качество изображения и повысить четкость',
        figure_video: 'Видео Фигуры',
        figure_video_desc: 'Преобразовать статические фото в видео одним кликом',
        video_style: 'Стиль Видео',
        video_style_desc: 'Изменить текущий стиль видео',

        // Раздел моделей
        models_title: 'Модели Изображения',
        model_sora2_desc: 'Реалистичная симуляция мира и аудио',
        try: 'Попробовать',
    },
    pt: {
        // Título da página
        pageTitle: 'Geração de Imagens com IA',
        pageSubtitle: 'Transforme sua criatividade em imagens impressionantes com os modelos de IA mais avançados',

        // Títulos do banner
        text_to_image_banner: 'Texto para Imagem',
        image_to_image_banner: 'Imagem para Imagem',

        // Descrições do carrossel
        carousel_desc_1: 'Personagens perfeitos, finalmente',
        carousel_desc_2: 'Fotorrealismo além da imaginação',
        carousel_desc_3: 'Sua visão, perfeitamente compreendida',

        // Seção de ferramentas
        tools_title: 'Ferramentas de Imagem',
        picture_of_life: 'Foto de Vida',
        picture_of_life_desc: 'Roupas para o fundo da imagem',
        image_elements_editing: 'Edição de Elementos de Imagem',
        image_elements_editing_desc: 'Ajustar manualmente fonte de cópia ou carregar metadados para editar imagens',
        image_cropping: 'Recorte de Imagem',
        image_cropping_desc: 'Recortar proporções de imagem',
        image_quality_upgrade: 'Melhoria de Qualidade de Imagem',
        image_quality_upgrade_desc: 'Melhorar a qualidade da imagem e aumentar a clareza',
        figure_video: 'Vídeo de Figura',
        figure_video_desc: 'Converter fotos estáticas em vídeo com um clique',
        video_style: 'Estilo de Vídeo',
        video_style_desc: 'Alterar o estilo de vídeo atual',

        // Seção de modelos
        models_title: 'Modelos de Imagem',
        model_sora2_desc: 'Simulação de mundo e áudio realista',
        try: 'Experimentar',
    },
    it: {
        // Titolo della pagina
        pageTitle: 'Generazione di Immagini IA',
        pageSubtitle: 'Trasforma la tua creatività in immagini straordinarie con i modelli IA più avanzati',

        // Titoli del banner
        text_to_image_banner: 'Testo a Immagine',
        image_to_image_banner: 'Immagine a Immagine',

        // Descrizioni del carosello
        carousel_desc_1: 'Personaggi perfetti, finalmente',
        carousel_desc_2: 'Fotorealismo oltre l\'immaginazione',
        carousel_desc_3: 'La tua visione, perfettamente compresa',

        // Sezione strumenti
        tools_title: 'Strumenti Immagine',
        picture_of_life: 'Foto di Vita',
        picture_of_life_desc: "Abbigliamento per lo sfondo dell'immagine",
        image_elements_editing: 'Modifica Elementi Immagine',
        image_elements_editing_desc: 'Regolare manualmente il font di copia o caricare metadati per modificare le immagini',
        image_cropping: 'Ritaglio Immagine',
        image_cropping_desc: "Ritagliare le proporzioni dell'immagine",
        image_quality_upgrade: 'Miglioramento Qualità Immagine',
        image_quality_upgrade_desc: "Migliorare la qualità dell'immagine e aumentare la chiarezza",
        figure_video: 'Video Figura',
        figure_video_desc: 'Convertire foto statiche in video con un clic',
        video_style: 'Stile Video',
        video_style_desc: 'Cambiare lo stile video attuale',

        // Sezione modelli
        models_title: 'Modelli Immagine',
        model_sora2_desc: 'Simulazione di mondo e audio realistica',
        try: 'Prova',
    },
    ar: {
        // عنوان الصفحة
        pageTitle: 'إنشاء صور بالذكاء الاصطناعي',
        pageSubtitle: 'حوّل إبداعك إلى صور مذهلة باستخدام أكثر نماذج الذكاء الاصطناعي تقدمًا',

        // عناوين اللافتة
        text_to_image_banner: 'نص إلى صورة',
        image_to_image_banner: 'صورة إلى صورة',

        // أوصاف الدوار
        carousel_desc_1: 'شخصيات مثالية، أخيرًا',
        carousel_desc_2: 'واقعية فوتوغرافية تفوق الخيال',
        carousel_desc_3: 'رؤيتك، مفهومة تمامًا',

        // قسم الأدوات
        tools_title: 'أدوات الصورة',
        picture_of_life: 'صورة الحياة',
        picture_of_life_desc: 'ملابس لخلفية الصورة',
        image_elements_editing: 'تحرير عناصر الصورة',
        image_elements_editing_desc: 'ضبط خط النسخ يدويًا أو تحميل البيانات الوصفية لتحرير الصور',
        image_cropping: 'قص الصورة',
        image_cropping_desc: 'قص نسب الصورة',
        image_quality_upgrade: 'ترقية جودة الصورة',
        image_quality_upgrade_desc: 'ترقية جودة الصورة وتحسين الوضوح',
        figure_video: 'فيديو الشكل',
        figure_video_desc: 'تحويل الصور الثابتة إلى فيديو بنقرة واحدة',
        video_style: 'نمط الفيديو',
        video_style_desc: 'تغيير نمط الفيديو الحالي',

        // قسم النماذج
        models_title: 'نماذج الصورة',
        model_sora2_desc: 'محاكاة عالم وصوت واقعية',
        try: 'تجربة',
        },
    th: {
        // Page title
        pageTitle: 'การสร้างภาพด้วย AI',
        pageSubtitle: 'เปลี่ยนความคิดสร้างสรรค์ของคุณให้เป็นภาพสุดตระการตาด้วยโมเดล AI ที่ล้ำสมัยที่สุด',

        // Banner titles
        text_to_image_banner: 'ข้อความเป็นภาพ',
        image_to_image_banner: 'ภาพเป็นภาพ',

        // Carousel descriptions
        carousel_desc_1: 'ตัวละครไร้ที่ติ ในที่สุด',
        carousel_desc_2: 'ความสมจริงเหนือจินตนาการ',
        carousel_desc_3: 'วิสัยทัศน์ของคุณ เข้าใจอย่างสมบูรณ์แบบ',

        // Tools section
        tools_title: 'เครื่องมือภาพ',
        picture_of_life: 'ภาพแห่งชีวิต',
        picture_of_life_desc: 'จัดวางเสื้อผ้าบนพื้นหลังของภาพ',
        image_elements_editing: 'แก้ไของค์ประกอบภาพ',
        image_elements_editing_desc: 'ปรับฟอนต์ข้อความด้วยตนเองหรืออัปโหลดเมทาดาตาเพื่อแก้ไขภาพ',
        image_cropping: 'ครอปรูปภาพ',
        image_cropping_desc: 'ครอปสัดส่วนของภาพ',
        image_quality_upgrade: 'ยกระดับคุณภาพภาพ',
        image_quality_upgrade_desc: 'เพิ่มคุณภาพภาพและความคมชัด',
        figure_video: 'วิดีโอตัวละคร',
        figure_video_desc: 'แปลงภาพนิ่งเป็นวิดีโอด้วยคลิกเดียว',
        video_style: 'สไตล์วิดีโอ',
        video_style_desc: 'เปลี่ยนสไตล์วิดีโอปัจจุบัน',

        // Models section
        models_title: 'โมเดลภาพ',
        model_sora2_desc: 'การจำลองโลกและเสียงที่สมจริง',
        try: 'ลองใช้',
        },
    da: {
        // Page title
        pageTitle: 'AI billedgenerering',
        pageSubtitle: 'Forvandl din kreativitet til fantastiske billeder med de mest avancerede AI‑modeller',

        // Banner titles
        text_to_image_banner: 'Tekst til billede',
        image_to_image_banner: 'Billede til billede',

        // Carousel descriptions
        carousel_desc_1: 'Fejlfri karakterer, endelig',
        carousel_desc_2: 'Fotorealisme ud over fantasien',
        carousel_desc_3: 'Din vision, perfekt forstået',

        // Tools section
        tools_title: 'Billedværktøjer',
        picture_of_life: 'Billede af liv',
        picture_of_life_desc: 'Påklædning til billedets baggrund',
        image_elements_editing: 'Redigering af billedelementer',
        image_elements_editing_desc: 'Juster skrifttype manuelt eller upload metadata for at redigere billeder',
        image_cropping: 'Billedbeskæring',
        image_cropping_desc: 'Beskær billedets proportioner',
        image_quality_upgrade: 'Forbedring af billedkvalitet',
        image_quality_upgrade_desc: 'Forbedr billedkvaliteten og øg klarheden',
        figure_video: 'Figurvideo',
        figure_video_desc: 'Gør statiske billeder til video med ét klik',
        video_style: 'Videostil',
        video_style_desc: 'Skift den aktuelle videostil',

        // Models section
        models_title: 'Billedmodeller',
        model_sora2_desc: 'Realistisk verden‑ og lydsimulation',
        try: 'Prøv',
        },
    no: {
        // Page title
        pageTitle: 'AI‑bildegenerering',
        pageSubtitle: 'Gjør kreativiteten din om til imponerende bilder med de mest avanserte AI‑modellene',

        // Banner titles
        text_to_image_banner: 'Tekst til bilde',
        image_to_image_banner: 'Bilde til bilde',

        // Carousel descriptions
        carousel_desc_1: 'Feilfrie karakterer, endelig',
        carousel_desc_2: 'Fotorealisme uten grenser',
        carousel_desc_3: 'Din visjon, perfekt forstått',

        // Tools section
        tools_title: 'Bildeverktøy',
        picture_of_life: 'Livsbilde',
        picture_of_life_desc: 'Påkledning for bildets bakgrunn',
        image_elements_editing: 'Redigering av bildeelementer',
        image_elements_editing_desc: 'Juster skrifttype manuelt eller last opp metadata for å redigere bilder',
        image_cropping: 'Bildebeskjæring',
        image_cropping_desc: 'Beskjær bildeproporsjoner',
        image_quality_upgrade: 'Oppgradering av bildekvalitet',
        image_quality_upgrade_desc: 'Forbedre bildekvalitet og skarphet',
        figure_video: 'Figurvideo',
        figure_video_desc: 'Gjør stillbilder om til video med ett klikk',
        video_style: 'Videostil',
        video_style_desc: 'Endre nåværende videostil',

        // Models section
        models_title: 'Billedmodeller',
        model_sora2_desc: 'Realistisk verdens‑ og lydsimulering',
        try: 'Prøv',
        },
    nl: {
        // Page title
        pageTitle: 'AI‑beeldgeneratie',
        pageSubtitle: 'Zet je creativiteit om in indrukwekkende beelden met de meest geavanceerde AI‑modellen',

        // Banner titles
        text_to_image_banner: 'Tekst naar beeld',
        image_to_image_banner: 'Beeld naar beeld',

        // Carousel descriptions
        carousel_desc_1: 'Foutloze personages, eindelijk',
        carousel_desc_2: 'Fotorealisme voorbij de verbeelding',
        carousel_desc_3: 'Jouw visie, perfect begrepen',

        // Tools section
        tools_title: 'Beeldtools',
        picture_of_life: 'Levensbeeld',
        picture_of_life_desc: 'Kleding voor de achtergrond van de afbeelding',
        image_elements_editing: 'Bildelementen bewerken',
        image_elements_editing_desc: 'Pas het lettertype handmatig aan of upload metadata om beelden te bewerken',
        image_cropping: 'Afbeelding bijsnijden',
        image_cropping_desc: 'Snijd de afbeeldingsverhoudingen bij',
        image_quality_upgrade: 'Beeldkwaliteit verbeteren',
        image_quality_upgrade_desc: 'Verbeter de beeldkwaliteit en verhoog de scherpte',
        figure_video: 'Figurenvideo',
        figure_video_desc: 'Zet statische beelden met één klik om naar video',
        video_style: 'Videostijl',
        video_style_desc: 'Wijzig de huidige videostijl',

        // Models section
        models_title: 'Beeldmodellen',
        model_sora2_desc: 'Realistische wereld‑ en audio‑simulatie',
        try: 'Probeer',
        },
    id: {
        // Page title
        pageTitle: 'Generasi Gambar AI',
        pageSubtitle: 'Ubah kreativitas Anda menjadi gambar menakjubkan dengan model AI paling canggih',

        // Banner titles
        text_to_image_banner: 'Teks ke Gambar',
        image_to_image_banner: 'Gambar ke Gambar',

        // Carousel descriptions
        carousel_desc_1: 'Karakter sempurna, akhirnya',
        carousel_desc_2: 'Fotorealisme melampaui imajinasi',
        carousel_desc_3: 'Visi Anda, dipahami dengan sempurna',

        // Tools section
        tools_title: 'Alat gambar',
        picture_of_life: 'Gambar kehidupan',
        picture_of_life_desc: 'Pakaian untuk latar belakang gambar',
        image_elements_editing: 'Edit elemen gambar',
        image_elements_editing_desc: 'Sesuaikan font teks secara manual atau unggah metadata untuk mengedit gambar',
        image_cropping: 'Pemotongan gambar',
        image_cropping_desc: 'Potong proporsi gambar',
        image_quality_upgrade: 'Peningkatan kualitas gambar',
        image_quality_upgrade_desc: 'Tingkatkan kualitas gambar dan kejernihan',
        figure_video: 'Video figur',
        figure_video_desc: 'Ubah gambar statis menjadi video dengan sekali klik',
        video_style: 'Gaya video',
        video_style_desc: 'Ubah gaya video saat ini',

        // Models section
        models_title: 'Model gambar',
        model_sora2_desc: 'Simulasi dunia dan audio yang realistis',
        try: 'Coba',
        },
    tr: {
        // Page title
        pageTitle: 'AI Görsel Üretimi',
        pageSubtitle: 'Yaratıcılığınızı en gelişmiş AI modelleriyle etkileyici görsellere dönüştürün',

        // Banner titles
        text_to_image_banner: 'Metinden Görsele',
        image_to_image_banner: 'Görselden Görsele',

        // Carousel descriptions
        carousel_desc_1: 'Kusursuz karakterler, nihayet',
        carousel_desc_2: 'Hayal gücünün ötesinde fotogerçekçilik',
        carousel_desc_3: 'Vizyonunuz, kusursuz şekilde anlaşıldı',

        // Tools section
        tools_title: 'Görsel araçları',
        picture_of_life: 'Yaşam resmi',
        picture_of_life_desc: 'Görselin arka planı için kıyafet',
        image_elements_editing: 'Görsel öğe düzenleme',
        image_elements_editing_desc: 'Metin fontunu manuel ayarla veya görseli düzenlemek için metadata yükle',
        image_cropping: 'Görsel kırpma',
        image_cropping_desc: 'Görsel oranlarını kırp',
        image_quality_upgrade: 'Görsel kalite yükseltme',
        image_quality_upgrade_desc: 'Görsel kalitesini artır ve netliği iyileştir',
        figure_video: 'Figür video',
        figure_video_desc: 'Statik görselleri tek tıkla videoya dönüştür',
        video_style: 'Video stili',
        video_style_desc: 'Mevcut video stilini değiştir',

        // Models section
        models_title: 'Görsel modelleri',
        model_sora2_desc: 'Gerçekçi dünya ve ses simülasyonu',
        try: 'Dene',
    },
}
